"use client"

import { useEffect } from "react"

function logClientError(label: string, err: unknown): void {
  if (err instanceof Error) {
    console.error(`[Lower ${label}]`, err.message, err.stack ?? err)
    return
  }
  console.error(`[Lower ${label}]`, err)
}

/**
 * Logs uncaught client errors with full message/stack (prod minified React still
 * surfaces native Error here; use DevTools + source maps for component stack).
 */
export function ClientDiagnostics() {
  useEffect(() => {
    const onError = (event: ErrorEvent) => {
      logClientError("window.error", event.error ?? event.message)
    }
    const onRejection = (event: PromiseRejectionEvent) => {
      logClientError("unhandledrejection", event.reason)
    }

    window.addEventListener("error", onError)
    window.addEventListener("unhandledrejection", onRejection)
    return () => {
      window.removeEventListener("error", onError)
      window.removeEventListener("unhandledrejection", onRejection)
    }
  }, [])

  return null
}
